<ul class="layout-menu">
  <div class="mt-4 mb-4">
    <app-profile-button [user]="user"></app-profile-button>
  </div>
  <li app-menuitem *ngFor="let item of mainModel; let i = index;" [item]="item" [index]="i" [root]="true"></li>
</ul>
<ul class="layout-menu layout-menu-bottom">
  <li app-menuitem *ngFor="let item of bottomModel; let i = index;" [item]="item" [index]="i" [root]="true"></li>
</ul>
